import { type FC } from 'react'

import { type ProspectDto } from '@api'
import { type Row } from '@tanstack/react-table'

import ExportIcon from '@/assets/icons/icon-download.svg'
import { Button } from '@/components/ui/button'

import { useExportAudit } from './useExportAudit'

interface Props {
  row: Row<ProspectDto>
}

export const ExportProspectAudit: FC<Props> = ({ row }) => {
  const { onExport, isExporting } = useExportAudit({ prospect: row.original })

  if (isExporting) {
    return (
      <Button
        variant="ghost"
        className="mr-2 p-1"
        isLoading
      >
        Exporting...
      </Button>
    )
  }

  return (
    <Button
      variant="ghost"
      className="mr-2 p-1"
      onClick={onExport}
      testId="prospect-export-button"
    >
      Export PDF
      <ExportIcon className="ml-1 h-6 w-6" />
    </Button>
  )
}
